import { render, staticRenderFns } from "./store-goods-category.vue?vue&type=template&id=339e8100"
import script from "./store-goods-category.vue?vue&type=script&lang=ts"
export * from "./store-goods-category.vue?vue&type=script&lang=ts"
import style0 from "./store-goods-category.vue?vue&type=style&index=0&id=339e8100&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports